import { SxProps } from '@mui/material';

export const productTagContainerSX = (tagBackgroundColor?: string): SxProps => ({
	display: 'inline',
	padding: '2px 5px',
	marginRight: '10px',
	borderRadius: '3px',
	maxWidth: 'fit-content',
	minWidth: 'fit-content',
	height: 'fit-content',
	backgroundColor: `productTagColor.${tagBackgroundColor}`,
});

export const productTagLabelSX: SxProps = {
	fontSize: '15px',
	fontWeight: '600',
	color: 'primary.contrastText',
};
